// src/api/auth.api.ts

import { get, post } from './client';
import { LoginCredentials, AuthResponse, ApiResponse, User } from '../types';

export const authApi = {
  login: (credentials: LoginCredentials) => {
    return post<AuthResponse>('/auth/login', credentials);
  },

  // Calls the server to clear the HttpOnly auth cookie
  logout: () => {
    return post('/auth/logout');
  },

  getMe: () => {
    return get<ApiResponse<User>>('/auth/me');
  },

  changePassword: (data: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    return post<ApiResponse>('/auth/change-password', data);
  },
};